import React, { useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import './HowItWorksRota.css';

const steps = [
  {
    label: 'Input data (natural language or Excel)',
    icon: '/images/Howit.png',
  },
  {
    label: 'Genix parses the content',
    icon: '/images/Records.png',
  },
  {
    label: 'Rota is auto-generated',
    icon: '/images/Auto.png',
  },
  {
    label: 'Review, export, or share',
    icon: '/images/review.png',
  },
];

const HowItWorksRota = () => {
  const [step, setStep] = useState(0);
  const [fileName, setFileName] = useState('');
  const fileInputRef = useRef(null);
  const timers = useRef([]);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-20% 0px -20% 0px' });

  const reset = () => {
    setStep(0);
    setFileName('');
    timers.current.forEach(clearTimeout);
    timers.current = [];
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && !file.name.match(/\.(xls|xlsx)$/i)) {
      alert('Only Excel files are supported!');
      e.target.value = '';
      return;
    }
    if (file) {
      setFileName(file.name);
      setStep(1);
      // Step 2: Parsing (simulate 2s)
      timers.current.push(setTimeout(() => {
        setStep(2);
        // Step 3: Rota generated (simulate 2s)
        timers.current.push(setTimeout(() => {
          setStep(3);
        }, 2000));
      }, 2000));
    }
  };

  // Clean up timers on unmount
  React.useEffect(() => () => timers.current.forEach(clearTimeout), []);

  return (
    <motion.section
      className="howitworks-roata-section"
      ref={ref}
      initial={{ opacity: 0, scale: 0.8 }}
      animate={isInView ? { opacity: 1, scale: 1 } : {}}
      transition={{ duration: 0.8, ease: 'easeOut' }}
    >
      <div className="howitworks-roata-container">
        {/* Left Side */}
        <div className="howitworks-roata-left">
          <h2 className="howitworks-roata-heading">How It Works</h2>
          <div className="howitworks-roata-steps">
            {steps.map((s, idx) => (
              <div
                key={s.label}
                className={`howitworks-roata-step${step === idx ? ' selected' : ''}`}
              >
                <span className="howitworks-roata-step-icon">
                  {s.icon && <img src={s.icon} alt="" style={{width: 24, height: 24, objectFit: 'contain'}} />}
                </span>
                <span>{s.label}</span>
              </div>
            ))}
          </div>
        </div>
        {/* Right Side */}
        <div className="howitworks-roata-right">
          {step === 0 && (
            <div className="howitworks-roata-upload-box">
              <img src="/images/XLS.png" alt="Excel" className="howitworks-roata-xls-icon" />
              <div
                className="howitworks-roata-file-drop"
                onClick={() => fileInputRef.current && fileInputRef.current.click()}
              >
                <input
                  type="file"
                  accept=".xls,.xlsx"
                  style={{ display: 'none' }}
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
                <div className="howitworks-roata-upload-label">Upload your file</div>
                <div className="howitworks-roata-upload-hint">*Click to upload</div>
              </div>
            </div>
          )}
          {step === 1 && (
            <div className="howitworks-roata-processing">
              <div className="howitworks-roata-processing-msg">Parsing your file...</div>
              <div className="howitworks-roata-processing-loader">
                <span className="dot" />
                <span className="dot" />
                <span className="dot" />
              </div>
            </div>
          )}
          {step === 2 && (
            <div className="howitworks-roata-generated">
              <div className="howitworks-roata-generated-title">Rota Generated</div>
              <div className="howitworks-roata-generated-table">
                <div className="row header">
                  <div>Summary</div>
                  <div>1 Monday</div>
                  <div>2 Monday</div>
                </div>
                <div className="row">
                  <div>
                    John wick<br /><span className="shifts">✓ 4 shifts</span>
                  </div>
                  <div>
                    <b>16:00-22:00</b><br />Doctor
                  </div>
                  <div>
                    <b>16:00-22:00</b><br />Doctor
                  </div>
                </div>
                <div className="row">
                  <div>
                    Elena pena<br /><span className="shifts">✓ 5 shifts</span>
                  </div>
                  <div>
                    <b>16:00-22:00</b><br />Doctor
                  </div>
                  <div>
                    <b>16:00-22:00</b><br />Doctor
                  </div>
                </div>
              </div>
            </div>
          )}
          {step === 3 && (
            <div className="howitworks-roata-share">
              <div className="howitworks-roata-share-title">Ready to share</div>
              <div className="howitworks-roata-share-box">
                <img src="/images/send.png" alt="Send" style={{width: 48, height: 48}} />
              </div>
              <button className="howitworks-roata-reset-btn" onClick={reset}>Start Over</button>
            </div>
          )}
        </div>
      </div>
    </motion.section>
  );
};

export default HowItWorksRota; 